import { SlotsPlaceholder } from '@wix/widget-plugins-ooi';
import React from 'react';
import { AvailabilityPluginDataHooks } from './constants';
import { useExperiments } from '@wix/yoshi-flow-editor';
import { usePreset } from '../../Hooks/usePreset';
import { AVAILABILITY_PLUGIN_SLOT_ID } from '../../../../constants/constants';

export interface AvailabilityPluginProps {}

export const AvailabilityPlugin: React.FC<AvailabilityPluginProps> = () => {
  const { experiments } = useExperiments();
  const { isCalendarPage, isCalendarWidget } = usePreset();

  const isCalendar = isCalendarPage || isCalendarWidget;

  return experiments.enabled('specs.bookings.calendarPluginUoU') &&
    isCalendar ? (
    <div data-hook={AvailabilityPluginDataHooks.ROOT}>
      <SlotsPlaceholder slotId={AVAILABILITY_PLUGIN_SLOT_ID} />
    </div>
  ) : null;
};
